import * as Yup from "yup";
import moment from "moment";
import outputSubmissionModel from "./outputSubmissionModel";
const {
  formField: {
    // info
    statementReportGuideline,
    //info
    howManyPublicationSubmitC2FReport,
    yourResearchField,
    publicationEvidence
  }
} = outputSubmissionModel;

// const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

const yesCollaboratorTop100 =
  "Yes, I have collaborator from Top 100 University Ranking or Subject Ranking.";
const yesCollaboratorInternationalInstitute =
  "Yes, I have collaborator from Top International Institute.";
const yesCollaboratorHighPerformanceProfessor =
  "Yes, I have collaborator who is a high performance professor but not coming from Top 100 University";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  Yup.object().shape({
    [statementReportGuideline.name]: Yup.string().required(
      `${statementReportGuideline.requiredErrorMsg}`
    )
  }),

  Yup.object().shape({
    [howManyPublicationSubmitC2FReport.name]: Yup.string().trim().required(
      `${howManyPublicationSubmitC2FReport.requiredErrorMsg}`
    ),
    [yourResearchField.name]: Yup.string().required(
      `${yourResearchField.requiredErrorMsg}`
    ),
    [publicationEvidence.name]: Yup.array().of(
      Yup.object().shape({
        [publicationEvidence.subMenu[0].journalRanking.name]:
          Yup.string().required(
            `${publicationEvidence.subMenu[0].journalRanking.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].publicationStatus.name]:
          Yup.string().required(
            `${publicationEvidence.subMenu[0].publicationStatus.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].typeResearchPublication.name]:
          Yup.string().trim().required(
            `${publicationEvidence.subMenu[0].typeResearchPublication.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].acceptedDate.name]:
          Yup.string().required(
            `${publicationEvidence.subMenu[0].acceptedDate.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].publishedDate.name]:
          Yup.string().required(
            `${publicationEvidence.subMenu[0].publishedDate.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].doi.name]: Yup.string().trim().required(
          `${publicationEvidence.subMenu[0].doi.requiredErrorMsg}`
        ),
        [publicationEvidence.subMenu[0].uploadResearchPublication.name]:
          Yup.object()
            .shape({
              [publicationEvidence.subMenu[0].uploadResearchPublication.file]:
                Yup.object()
            })
            .nullable()
            .required(
              `${publicationEvidence.subMenu[0].uploadResearchPublication.requiredErrorMsg}`
            ),
        [publicationEvidence.subMenu[0].articleTitle.name]:
          Yup.string().trim().required(
            `${publicationEvidence.subMenu[0].articleTitle.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].journalName.name]:
          Yup.string().trim().required(
            `${publicationEvidence.subMenu[0].journalName.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].subjectAreaCategory.name]:
          Yup.string().trim().required(
            `${publicationEvidence.subMenu[0].subjectAreaCategory.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].journalRankingPercentagePercentile
          .name]: Yup.string().trim().required(
          `${publicationEvidence.subMenu[0].journalRankingPercentagePercentile.requiredErrorMsg}`
        ),
        [publicationEvidence.subMenu[0].screenshotJournalRankingEvidence.name]:
          Yup.object()
            .shape({
              [publicationEvidence.subMenu[0].screenshotJournalRankingEvidence
                .file]: Yup.mixed()
            })
            .nullable()
            .required(
              `${publicationEvidence.subMenu[0].screenshotJournalRankingEvidence.requiredErrorMsg}`
            ),
        [publicationEvidence.subMenu[0].firstAuthor.name]:
          Yup.string().trim().required(
            `${publicationEvidence.subMenu[0].firstAuthor.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].correspondingAuthor.name]:
          Yup.string().trim().required(
            `${publicationEvidence.subMenu[0].correspondingAuthor.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].collaboratorFromTop100.name]:
          Yup.string().required(
            `${publicationEvidence.subMenu[0].collaboratorFromTop100.requiredErrorMsg}`
          ),
        [publicationEvidence.subMenu[0].collaboratorName.name]:
          Yup.string().when(
            publicationEvidence.subMenu[0].collaboratorFromTop100.name,
            {
              is: (choose) =>
                choose === yesCollaboratorTop100 ||
                choose === yesCollaboratorInternationalInstitute ||
                choose === yesCollaboratorHighPerformanceProfessor,
              then: Yup.string().required(
                `${publicationEvidence.subMenu[0].collaboratorName.requiredErrorMsg}`
              )
            }
          ),
        [publicationEvidence.subMenu[0].universityInstituteCollaborator.name]:
          Yup.string().when(
            publicationEvidence.subMenu[0].collaboratorFromTop100.name,
            {
              is: (choose) =>
                choose === yesCollaboratorTop100 ||
                choose === yesCollaboratorInternationalInstitute ||
                choose === yesCollaboratorHighPerformanceProfessor,
              then: Yup.string().required(
                `${publicationEvidence.subMenu[0].universityInstituteCollaborator.requiredErrorMsg}`
              )
            }
          ),
        [publicationEvidence.subMenu[0].referenceWorldRankingStatus.name]:
          Yup.string().when(
            publicationEvidence.subMenu[0].collaboratorFromTop100.name,
            {
              is: (choose) => choose === yesCollaboratorTop100,
              then: Yup.string().required(
                `${publicationEvidence.subMenu[0].referenceWorldRankingStatus.requiredErrorMsg}`
              )
            }
          ),
        [publicationEvidence.subMenu[0].worldRankingYear.name]:
          Yup.string().when(
            publicationEvidence.subMenu[0].collaboratorFromTop100.name,
            {
              is: (choose) => choose === yesCollaboratorTop100,
              then: Yup.string().required(
                `${publicationEvidence.subMenu[0].worldRankingYear.requiredErrorMsg}`
              )
            }
          ),
        [publicationEvidence.subMenu[0].noWorldRanking.name]: Yup.string().when(
          publicationEvidence.subMenu[0].collaboratorFromTop100.name,
          {
            is: (choose) => choose === yesCollaboratorTop100,
            then: Yup.string().required(
              `${publicationEvidence.subMenu[0].noWorldRanking.requiredErrorMsg}`
            )
          }
        ),
        [publicationEvidence.subMenu[0].evidenceTopInternationalInstitute.name]:
          Yup.object()
            .when(publicationEvidence.subMenu[0].collaboratorFromTop100.name, {
              is: (choose) => choose === yesCollaboratorInternationalInstitute,
              then: Yup.object()
                .shape({
                  [publicationEvidence.subMenu[0]
                    .evidenceTopInternationalInstitute.file]: Yup.mixed()
                })
                .nullable()
                .required(
                  `${publicationEvidence.subMenu[0].evidenceTopInternationalInstitute.requiredErrorMsg}`
                )
            })
            .nullable(),
        [publicationEvidence.subMenu[0].evidenceHighPerformanceProfessor.name]:
          Yup.object()
            .when(publicationEvidence.subMenu[0].collaboratorFromTop100.name, {
              is: (choose) =>
                choose === yesCollaboratorHighPerformanceProfessor,
              then: Yup.object()
                .shape({
                  [publicationEvidence.subMenu[0]
                    .evidenceHighPerformanceProfessor.file]: Yup.mixed()
                })
                .nullable()
                .required(
                  `${publicationEvidence.subMenu[0].evidenceHighPerformanceProfessor.requiredErrorMsg}`
                )
            })
            .nullable()
      })
    )
  })
];
